import styled, { keyframes, css } from 'styled-components';

const blinkAnimation = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

export const OverlayContainer = styled.div<{ $isBlinking: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1.5rem;
  background-color: #ef4444; /* Red bg */
  color: white;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  ${(props) =>
    props.$isBlinking &&
    css`
      animation: ${blinkAnimation} 0.5s linear 5; /* Blink 5 times (2.5s total) */
    `}
`;

export const AlertIcon = styled.span`
  font-size: 2rem;
`;
